// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2355":"04145c41720ffb68","6076":"a6805b5316c92945","9715":"6b1adb925a8f117d"}[chunkId] + ".css";
};